import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { useEffect } from "react";

import { useThunkDispatch } from "@/redux/dispatcher";
import { CTAAction } from "@/redux/modules/api/data/cart/@types/cart.types";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import { TApiAction } from "@/redux/store.types";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";

type Props = {
    product: CartItem | null;
    toType: DeliveryType;
};

const ChangeDeliveryAction = ({ product, toType }: Props) => {
    const dispatch = useThunkDispatch();
    const { closeDialog, setLoading } = useCallToActionsContext();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (product) {
            setLoading(true);
            dispatch(
                CartModule.updateCartItem(product.id!, product.quantity, toType)
            ).then((action: TApiAction) => {
                if (action.type === CartModule.APIStatus.SUCCESS) {
                    closeDialog();
                }
            });
        }
    }, []);

    return null;
};

const changeDelivery =
    (type: DeliveryType): CTAAction =>
    (product: CartItem | null) => {
        return (
            <ChangeDeliveryAction
                product={product}
                toType={type}
            />
        );
    };

export default changeDelivery;
